/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseImageGenerationCallPartialImageEvent = {
  type: "response.image_generation_call.partial_image";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
  partialImageIndex: number;
  partialImageB64: string;
};

/** @internal */
export const ResponseImageGenerationCallPartialImageEvent$inboundSchema:
  z.ZodType<
    ResponseImageGenerationCallPartialImageEvent,
    z.ZodTypeDef,
    unknown
  > = z.object({
    type: z.literal("response.image_generation_call.partial_image"),
    sequence_number: z.number().int(),
    item_id: z.string(),
    output_index: z.number().int(),
    partial_image_index: z.number().int(),
    partial_image_b64: z.string(),
  }).transform((v) => {
    return remap$(v, {
      "sequence_number": "sequenceNumber",
      "item_id": "itemId",
      "output_index": "outputIndex",
      "partial_image_index": "partialImageIndex",
      "partial_image_b64": "partialImageB64",
    });
  });
/** @internal */
export type ResponseImageGenerationCallPartialImageEvent$Outbound = {
  type: "response.image_generation_call.partial_image";
  sequence_number: number;
  item_id: string;
  output_index: number;
  partial_image_index: number;
  partial_image_b64: string;
};

/** @internal */
export const ResponseImageGenerationCallPartialImageEvent$outboundSchema:
  z.ZodType<
    ResponseImageGenerationCallPartialImageEvent$Outbound,
    z.ZodTypeDef,
    ResponseImageGenerationCallPartialImageEvent
  > = z.object({
    type: z.literal("response.image_generation_call.partial_image"),
    sequenceNumber: z.number().int(),
    itemId: z.string(),
    outputIndex: z.number().int(),
    partialImageIndex: z.number().int(),
    partialImageB64: z.string(),
  }).transform((v) => {
    return remap$(v, {
      sequenceNumber: "sequence_number",
      itemId: "item_id",
      outputIndex: "output_index",
      partialImageIndex: "partial_image_index",
      partialImageB64: "partial_image_b64",
    });
  });

export function responseImageGenerationCallPartialImageEventToJSON(
  responseImageGenerationCallPartialImageEvent:
    ResponseImageGenerationCallPartialImageEvent,
): string {
  return JSON.stringify(
    ResponseImageGenerationCallPartialImageEvent$outboundSchema.parse(
      responseImageGenerationCallPartialImageEvent,
    ),
  );
}
export function responseImageGenerationCallPartialImageEventFromJSON(
  jsonString: string,
): SafeParseResult<
  ResponseImageGenerationCallPartialImageEvent,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ResponseImageGenerationCallPartialImageEvent$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'ResponseImageGenerationCallPartialImageEvent' from JSON`,
  );
}
